module.exports = __webpack_public_path__ + "img/icon-23-gr.32ed5b4b.svg";